import React from 'react';
import { PageHeaderComposition } from '@csv/styleguide/src/features/page-header/page-header';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Container from '@csv/styleguide/src/elements/container/container';
import { PageBody } from '../features/content-page/content-page';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';

const SchooltoernooiPage = ({ data }) => {
  return (
    <Layout>
      <SEO
        title="Schooltoernooi"
        description="Informatie over het jaarlijkse schooltoernooi bij CSV Handbal Castricum."
      />
      <PageHeaderComposition
        title="Schooltoernooi"
        byline="Kom handballen bij CSV!"
      />
      <Container>
        <PageBody>
          <p>
            Zondag 29 juni 2025 vindt weer het jaarlijkse
            CSV-Schoolhandbaltoernooi plaats. Een gezellige en sportieve
            afsluiter van het schooljaar! Dit toernooi is mede mogelijk gemaakt
            door De Triangel Groep. Dit jaar wordt het CSV-Schoolhandbaltoernooi
            georganiseerd voor de basisschoolgroepen 3/4,5 en 6 uit Castricum en
            omstreken. Het toernooi is van 10.00 tot +/-17.00 uur (afhankelijk
            van de aanmeldingen per poule). We spelen per groep in een vast
            dagdeel\tijdsblok. Dit om lange wachttijden voor spelers en
            supporters acceptabel te houden.
          </p>
          <p>
            Het toernooi wordt gespeeld op ons gezellige clubterrein op
            Wouterland. Adres: Van Haerlemlaan 27, 1901JM, Castricum
          </p>
          <p>
            We spelen met gemengde teams, dus jongens en meiden door elkaar.
            <ul>
              <li>
                Groep 3/4. Combinatie van deze groepen. Spelen op half veld. Een
                team bestaat uit minimaal 6 spelers. 5 in het veld en 1 wissel.
              </li>
              <li>
                Groep 5. Spelen op heel veld. Een team bestaat uit minimaal 8
                spelers. 7 in het veld en 1 wissel.
              </li>
              <li>
                Groep 6. Spelen op heel veld. Een team bestaat uit minimaal 8
                spelers. 7 in het veld en 1 wissel.
              </li>
            </ul>
          </p>

          <p>
            Hieronder de links naar de flyer, die ook verzonden is naar de
            scholen. En een poster met kort wat spelregels. En natuurlijk het
            allerbelangrijkste: het inschrijfformulier. Wij hopen jullie
            allemaal te zien voor een sportieve en mooie dag op Wouterland.
          </p>
          <a
            href="https://forms.gle/wzbTEWK7T2bx99Sh9"
            target="_blank"
            rel="noopener noreferrer"
          >
            Inschrijfformulier
          </a>
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://drive.google.com/file/d/1kBf8FYP35J9SoDwEfbYhf_DPVUU8z_K4/view?usp=drive_link"
          >
            Promotieflyer
          </a>
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://drive.google.com/file/d/1akVraeLa01thhTb19h9TkZRN-XV49p5i/view?usp=sharing
          "
          >
            Spelregels
          </a>
          {data.file &&
            data.file.childImageSharp &&
            data.file.childImageSharp.fluid && (
              <Img fluid={data.file.childImageSharp.fluid} />
            )}
        </PageBody>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query SchoolhandbalQuery {
    file(relativePath: { eq: "schoolhandbal.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 720) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

export default SchooltoernooiPage;
